"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMultiSite = void 0;
var _react = require("react");
var _contexts = require("../contexts");
/*
 * Copyright (c) 2022, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

/**
 * Custom React hook to get the function that returns usefule multi-site values, the site, the locale and
 * the funtion used to build URLs following the App configuration.
 * @returns {{site, locale, buildUrl: (function(*, *, *): *)}}
 */
const useMultiSite = () => {
  const context = (0, _react.useContext)(_contexts.MultiSiteContext);
  if (context === undefined) {
    throw new Error('useMultiSite must be used within MultiSiteProvider');
  }
  const {
    buildUrl: originalFn,
    site,
    locale
  } = context;
  const buildUrl = (0, _react.useCallback)((path, siteRef, localeRef) => {
    return originalFn(path, siteRef ? siteRef : (site === null || site === void 0 ? void 0 : site.alias) || (site === null || site === void 0 ? void 0 : site.id), localeRef ? localeRef : (locale === null || locale === void 0 ? void 0 : locale.alias) || (locale === null || locale === void 0 ? void 0 : locale.id));
  }, [originalFn, site, locale]);
  return {
    site,
    locale,
    buildUrl
  };
};
exports.useMultiSite = useMultiSite;